import React from "react";
import { Link } from "react-router-dom";
import { SITE, SOCIAL, UI } from "../../content/site";
import { useLanguage } from "../../i18n/LanguageContext";

// Minimal footer, fixed to the bottom of the viewport so it is always visible.
export default function SiteFooter() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer className="dp-footer">
      <p className="dp-footer__line">
        © {year} {SITE.legalName}
      </p>
      <p className="dp-footer__line">{SITE.address}</p>
      <p className="dp-footer__line dp-footer__links">
        <span>{t(SITE.cities)}</span>
        <Link to="/privacy" className="dp-footer__link">
          {t(UI.privacy)}
        </Link>
        {SOCIAL.map((s) => (
          <a
            key={s.label}
            href={s.href}
            className="dp-footer__link"
            target="_blank"
            rel="noreferrer noopener"
          >
            {s.label} ↗
          </a>
        ))}
      </p>
    </footer>
  );
}
